import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '../style-comps/Common.styles';
import { updatePassword, updateUser, clearAuthStorage } from '../services/api';
import PasswordCheckIcon from '../Assets/Password-check.svg';
import PasswordCheckedIcon from '../Assets/Password-checked.svg';


import {
    LeftContainer,
    Title,
    Subtitle,
    RightContainer,
    SectionTitle,
    ProfilePhotoContainer,
    ImagePreview,
    ImageRequirements,
    UserDetailsContainer,
    InputFieldRow,
    SuccessMessage,
    ImageWrapper,
    ProfileImgWrapper,
    BtnWrapper,
    RemoveBtn,
    InputLabel,
    InputGroup,
    Star,
    AvatarBox,
    AvatarImage,
    AvatarCheckmark,
    StyledPopupOverlay,
    StyledPopupBox,
    StyledPopupLeft,
    StyledPopupRight,
    KoalaImage,
    PopupButton,
    PopupContainer
} from '../style-comps/Setting.styles';
import Button from '../components/Button';
import Input from '../components/Input';
import { H3 } from '../style-comps/Common.styles';
import { GlobalStyle } from '../style-comps/GlobalStyles';
import { getUserById } from '../services/api';

const Setting = () => {
    const [formData, setFormData] = useState({
        firstName: 'Joseph',
        lastName: 'kozy',
        phone: '012345678',
        password: '',
    });
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState(false);
    const [profileImage, setProfileImage] = useState(null);
    const avatarOptions = [
        "/Assets/mrK01.png",
        "/Assets/mrK02.png",
        "/Assets/mrK03.png",
        "/Assets/mrK04.png",
    ];
    const navigate = useNavigate();
    const [showPopup, setShowPopup] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [passwordChecks, setPasswordChecks] = useState({
        length: false,
        upper: false,
        lower: false,
        number: false,
        symbol: false,
    });



    useEffect(() => {
        const savedImage = localStorage.getItem('profileImage');
        const existsInOptions = avatarOptions.includes(savedImage);

        if (savedImage && existsInOptions) {
            setProfileImage(savedImage);
        } else {
            setProfileImage(avatarOptions[0]);
        }
    }, []);


    useEffect(() => {
        const fetchUserData = async () => {
            const token = localStorage.getItem('authToken');
            const userId = localStorage.getItem('userId');


            console.log("取得的 userId:", userId);

            if (token && userId) {
                try {
                    const userData = await getUserById(userId, token);
                    console.log("從 API 取得的使用者資料:", userData);

                    setFormData({
                        userName: userData?.UserName || formData.UserName || '',
                        lastName: userData?.LastName || formData.LastName || '',
                        phone: userData?.Phone || formData.Phone || '',
                        password: '',
                        confirmPassword: '',
                        oldPassword: '',
                    });
                } catch (error) {
                    console.log(`API 錯誤, 狀態碼: ${error.response?.status}`);
                    console.log(`錯誤訊息: ${error.response?.data?.message || error.message}`);
                }
            } else {
                console.log("缺少 token 或 userId，無法取得使用者資料。");
            }
        };

        fetchUserData();
        const requireChange = localStorage.getItem("requirePasswordChange");
        if (requireChange === "true") {
            setShowPopup(true); // 這是你剛剛定義的 state
        }
    }, []);

    useEffect(() => {
        console.log("formData 更新:", formData);
    }, [formData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        setErrors({
            ...errors,
            [name]: '',
        });

        if (name === "password") {
            const lengthCheck = value.length >= 8;
            const upper = /[A-Z]/.test(value);
            const lower = /[a-z]/.test(value);
            const number = /\d/.test(value);
            const symbol = /[^A-Za-z0-9]/.test(value);

            setPasswordChecks({
                length: lengthCheck,
                upper,
                lower,
                number,
                symbol,
            });
        }
    };


    const validateForm = () => {
        const newErrors = {};

        const password = formData.password;

        if (!password) {
            newErrors.password = "Password is required.";
        } else {
            const hasUpperCase = /[A-Z]/.test(password);
            const hasLowerCase = /[a-z]/.test(password);
            const hasNumber = /\d/.test(password);
            const hasSymbol = /[^A-Za-z0-9]/.test(password);

            const conditionsPassed = [hasUpperCase, hasLowerCase, hasNumber, hasSymbol].filter(Boolean).length;

            if (password.length < 8 || conditionsPassed < 3) {
                newErrors.password = "Password must be over 8 characters and include at least 3 of: uppercase, lowercase, numbers, special characters.";
            }
        }

        return newErrors;
    };



    const handleSave = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const userId = localStorage.getItem("userId");
        const updateFields = [];

        if (formData.password && formData.password.length >= 2) {
            updateFields.push({
                op: "replace",
                path: "/Password",
                value: formData.password,
            });
        }

        if (profileImage) {
            updateFields.push({
                op: "replace",
                path: "/avatar",
                value: profileImage.replace("/Assets/", ""),
            });
        }

        if (updateFields.length === 0) {
            alert("Please upload a profile image or enter a valid password.");
            return;
        }

        try {
            await updateUser(userId, updateFields);
            localStorage.setItem("profileImage", profileImage);
            localStorage.setItem("requirePasswordChange", "false");

            // 先清掉登入狀態，避免根路由因為 isLoggedIn 還是 true 又把人導回 /dashboard
            clearAuthStorage();

            alert("Password updated! Please sign in again using your new password.");

            // 整頁重新載入回登入頁，App 會以「沒有 token」重新初始化 → isLoggedIn = false
            window.location.href = "/";
        } catch (error) {
            console.error("❌ 更新失敗:", error);
            alert("Failed to update profile.");
        }

    };




    useEffect(() => {
        if (success) {
            const timer = setTimeout(() => setSuccess(false), 3000);  // 3秒後隱藏
            return () => clearTimeout(timer);
        }
    }, [success]);


    return (
        <>
            <GlobalStyle />
            {showPopup && (
                <StyledPopupOverlay>
                    <StyledPopupBox>
                        <StyledPopupLeft>
                            <h3 style={{ margin: 0 }}>Welcome aboard !</h3>
                        </StyledPopupLeft>

                        <PopupContainer>
                            <StyledPopupRight>
                                <p style={{ margin: '12px 0', fontSize: '14px' }}>
                                    Please change your password on first login. It must be over 8 characters and include at least 3 of: uppercase, lowercase, numbers, or symbols.
                                </p>
                            </StyledPopupRight>
                            <PopupButton onClick={() => setShowPopup(false)}>Got it !</PopupButton>
                        </PopupContainer>
                        <KoalaImage src="/Assets/mrK01.png" alt="Koala mascot" />
                    </StyledPopupBox>
                </StyledPopupOverlay>


            )}


            <Container>
                <LeftContainer>
                    <Title>Setting</Title>
                    <Subtitle>You can easily update your password and profile photo here.</Subtitle>
                </LeftContainer>

                <RightContainer>
                    <SectionTitle>Profile</SectionTitle>
                    <ProfilePhotoContainer>
                        <H3>Profile Photo</H3>
                        <ProfileImgWrapper>
                            <ImageWrapper>
                                <ImagePreview src={profileImage || avatarOptions[0]} alt="Selected Avatar" />
                                <div style={{ display: "flex", gap: "12px", marginTop: "12px", flexWrap: "nowrap" }}>
                                    {avatarOptions.map((url, index) => (
                                        <AvatarBox
                                            key={index}
                                            isSelected={profileImage === url}
                                            onClick={() => {
                                                setProfileImage(url);
                                                localStorage.setItem("profileImage", url);
                                                window.dispatchEvent(new Event("storage"));
                                            }}
                                        >
                                            <AvatarImage src={url} alt={`Avatar ${index + 1}`} />

                                            {profileImage === url && (
                                                <AvatarCheckmark>
                                                    <span>K</span>
                                                </AvatarCheckmark>
                                            )}
                                        </AvatarBox>

                                    ))}
                                </div>

                            </ImageWrapper>

                            {/* <ImageRequirements>
                                <p>Image requirements:</p>
                                <ul>
                                    <li>Min. 400 x 400px</li>
                                    <li>Max. 2MB</li>
                                    <li>Your face pic</li>
                                </ul>
                            </ImageRequirements> */}

                        </ProfileImgWrapper>
                    </ProfilePhotoContainer>

                    <ProfilePhotoContainer>
                        <H3>User Details</H3>
                        <UserDetailsContainer onSubmit={handleSave}>

                            <InputFieldRow>
                                <InputGroup>
                                    <InputLabel>Username</InputLabel>
                                    <Input
                                        name="Username"
                                        value={formData.userName}
                                        onChange={handleInputChange}
                                        disabled={true}
                                    />
                                </InputGroup>
                                <InputGroup>
                                    <InputLabel>Full Name</InputLabel>
                                    <Input
                                        name="fullName"
                                        value={formData.lastName}
                                        onChange={handleInputChange}
                                        disabled={true}
                                    />
                                </InputGroup>
                            </InputFieldRow>

                            <InputGroup>
                                <InputLabel>Phone</InputLabel>
                                <Input
                                    name="phone"
                                    placeholder="012345678"
                                    value={formData.phone}
                                    onChange={handleInputChange}
                                    disabled={true}
                                />
                            </InputGroup>

                            <InputGroup>
                                <InputLabel>Reset Password<Star>*</Star></InputLabel>
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <Input
                                        name="password"
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Reset Password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        isError={!!errors.password}
                                        style={{ paddingRight: '40px' }}
                                    />
                                    <img
                                        src={showPassword ? "/Assets/Eyes-open.png" : "/Assets/Eyes-close.png"}
                                        alt="toggle password visibility"
                                        onClick={() => setShowPassword(prev => !prev)}
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            right: '12px',
                                            transform: 'translateY(-50%)',
                                            width: '18px',
                                            height: '18px',
                                            cursor: 'pointer',
                                            opacity: 0.6
                                        }}
                                    />
                                </div>
                            </InputGroup>

                            <div style={{ marginTop: "8px", marginLeft: "4px", fontSize: "14px", display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <img
                                        src={passwordChecks.length ? PasswordCheckedIcon : PasswordCheckIcon}
                                        alt="check"
                                        style={{ width: "16px", height: "16px" }}
                                    />
                                    <span style={{ color: passwordChecks.length ? "#61cbc9" : "#999" }}>Must be over 8 characters</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <img
                                        src={passwordChecks.upper ? PasswordCheckedIcon : PasswordCheckIcon}
                                        alt="check"
                                        style={{ width: "16px", height: "16px" }}
                                    />
                                    <span style={{ color: passwordChecks.upper ? "#61cbc9" : "#999" }}>At least one uppercase letter</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <img
                                        src={passwordChecks.lower ? PasswordCheckedIcon : PasswordCheckIcon}
                                        alt="check"
                                        style={{ width: "16px", height: "16px" }}
                                    />
                                    <span style={{ color: passwordChecks.lower ? "#61cbc9" : "#999" }}>At least one lowercase letter</span>
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <img
                                        src={passwordChecks.number ? PasswordCheckedIcon : PasswordCheckIcon}
                                        alt="check"
                                        style={{ width: "16px", height: "16px" }}
                                    />
                                    <span style={{ color: passwordChecks.number ? "#61cbc9" : "#999" }}>At least one number</span>
                                </div>

                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <img
                                        src={passwordChecks.symbol ? PasswordCheckedIcon : PasswordCheckIcon}
                                        alt="check"
                                        style={{ width: "16px", height: "16px" }}
                                    />
                                    <span style={{ color: passwordChecks.symbol ? "#61cbc9" : "#999" }}>At least one symbol</span>
                                </div>

                            </div>





                            {/* 成功訊息 */}
                            {success && (
                                <SuccessMessage>
                                    <span>Successfully Saved.</span> Your profile settings have been saved.
                                </SuccessMessage>
                            )}

                            <div style={{ textAlign: 'right' }}>
                                <Button
                                    label="Save"
                                    type="submit"
                                    style={{
                                        backgroundColor: "#61cbc9",
                                        color: "#ffffff",
                                        padding: "12px",
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        border: "none",
                                        borderRadius: "8px",
                                        cursor: "pointer",
                                    }}
                                >
                                    Save
                                </Button>
                            </div>
                        </UserDetailsContainer>
                    </ProfilePhotoContainer>
                </RightContainer>
            </Container>
        </>
    );
};

export default Setting;